import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import DataIdCalculator from '../components/tools/DataIdCalculator';

const DataIdCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="data-id-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Data ID Calculator"
        description="See how AUTOSAR E2E Profile 1 folds a 16-bit Data ID into the CRC to protect against masquerading, across all four inclusion modes."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="data-id-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <DataIdCalculator />
          <ToolGuideCta guidePath="/tools/data-id-calculator/guide" toolName="Data ID Calculator" />
        </div>
      </section>
    </div>
  );
};

export default DataIdCalculatorPage;
